import { Cache } from "aws-amplify";
import { Auth } from "aws-amplify";
import { AmplifyEventBus } from "aws-amplify-vue";
//import { ConsoleLogger } from "@aws-amplify/core";

const app = {
  state: {
    user: null, //AWS Cognito
    //tipoCliente: Cache.getItem("tipoCliente") || 'null',
    tipoCliente: "proveedor",
    empresa: null,
    empresas: [],
    suscripcion: null,
    drawer: Cache.getItem("drawerStatus")
      ? !!+Cache.getItem("drawerStatus")
      : true,
    language: Cache.getItem("language") || "es",
    busy: false,
    busyText: "Cargando...",
    misCpcs: Cache.getItem("cpcs") || [],
    route: null,
  },
  mutations: {
    SET_ROUTE(state, route) {
      state.route = route;
    },
    TOGGLE_SIDEBAR: (state) => {
      state.drawer = !state.drawer;
      if (state.drawer) {
        Cache.setItem("drawerStatus", 1);
      } else {
        Cache.setItem("drawerStatus", 0);
      }
    },
    CLOSE_SIDEBAR: (state) => {
      Cache.setItem("drawerStatus", 0);
      state.drawer = false;
    },
    colapsed(state) {
      state.drawer = !state.drawer;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    SET_TIPO_CLIENTE(state, val) {
      console.log("SET_TIPO_CLIENTE");
      Cache.setItem("tipoCliente", val);
      state.tipoCliente = val;
    },
    SET_EMPRESA(state, empresa) {
      console.log("SET_EMPRESA");
      state.empresa = empresa;
      state.empresas = [];
      state.empresas.push({
        label: empresa.razonSocial,
        value: empresa.ruc,
      });
      console.log(empresa);
      console.log(state.empresas);
    },
    SET_SUSCRIPCION(state, suscripcion) {
      state.suscripcion = suscripcion;
    },
    SET_USER_ATTRIBUTES(state, attributes) {
      state.user.attributes = attributes;
    },
    SET_LANGUAGE: (state, language) => {
      console.log("SET_LANGUAGE");
      Cache.setItem("language", language);
      state.language = language;
    },
    SET_MIS_CPCS: (state, cpcs) => {
      console.log("SET_MIS_CPCS");
      Cache.setItem("cpcs", cpcs);
      state.misCpcs = cpcs;
    },
    SET_BUSY_INDICATOR: (state, busy) => {
      console.log(busy);
      state.busy = !state.busy;
    },
    SET_BUSY_TEXT: (state, busyText) => {
      state.busyText = busyText;
    },
  },
  actions: {
    setRoute({ commit }, route) {
      console.log("action: setRoute", route);
      commit("SET_ROUTE", route);
    },
    setUser({ commit }, user) {
      //console.log("action: setUser", user);
      commit("SET_USER", user);
    },
    setEmpresa({ commit }, empresa) {
      //console.log("action: setUser", user);
      commit("SET_EMPRESA", empresa);
      commit("SET_TIPO_CLIENTE", empresa.tipoCliente);
    },
    setSuscripcion({ commit }, suscripcion) {
      //console.log("action: setUser", user);
      commit("SET_SUSCRIPCION", suscripcion);
    },
    setUserAttributes({ commit }, attributes) {
      commit("SET_USER_ATTRIBUTES", attributes);
    },
    toggleSideBar({ commit }) {
      console.log("action: toggleSideBar");
      commit("TOGGLE_SIDEBAR");
    },
    closeSideBar({ commit }) {
      commit("CLOSE_SIDEBAR");
    },
    setLanguage({ commit }, language) {
      console.log("Set language action", language);
      commit("SET_LANGUAGE", language);
    },
    setMisCpcs({ commit }, cpcs) {
      console.log("Set misCpcs action", cpcs);
      commit("SET_MIS_CPCS", cpcs);
    },
    setBusyIndicator({ commit }, [busy, busyText]) {
      commit("SET_BUSY_INDICATOR", busy);
      commit("SET_BUSY_TEXT", busyText);
    },
    signOut() {
      Auth.signOut()
        .then(() => {
          return AmplifyEventBus.$emit("authState", "signedOut");
        })
        .catch(err => console.log(err));
    }
  },
};

export default app;
